import { Icon, IconProps } from '@toggle/design-system';
import { CatalystInsightCategory, CatalystSubcategories } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './CatalystInsightTooltip.styles';

export interface CatalystInsightTooltipProps {
  category: CatalystInsightCategory;
  iconProps: IconProps;
  subCategory?: CatalystSubcategories;
}

export const CatalystInsightTooltip = ({
  iconProps,
  category,
  subCategory,
}: CatalystInsightTooltipProps) => {
  const { t } = useTranslation(['insights']);

  return (
    <S.TooltipWrapper>
      <Icon {...iconProps} size={32} />
      <S.RightWrapper>
        <S.TitleLabel>
          {category === 'company'
            ? t('insights:catalyst.titleCompanyCatalyst')
            : t('insights:catalyst.titleMarketCatalyst')}
        </S.TitleLabel>
        <S.CategoryLabel>
          {
            /* i18next-extract-mark-context-next-line ["financial_operational_updates", "corporate_actions_strategic_announcements", "management_leadership_changes", "legal_regulatory_events"] */
            subCategory ? t(`catalyst.subcategories.${subCategory}`) : ''
          }
        </S.CategoryLabel>
      </S.RightWrapper>
    </S.TooltipWrapper>
  );
};
